var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegoModalLayout',{scopedSlots:_vm._u([{key:"header",fn:function({ close }){return [_c('header',{staticClass:"header"},[_c('ModalHeaderControls'),_c('AddBtn',{staticClass:"close",on:{"click":close}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }